import { LOG_TYPES } from '../../constants/logTypeRegistry';

const createTimelineType = ({
  type,
  label,
  icon,
  color,
  entryGroup,
  collection,
  isRootCollection = false,
  isChildSubCollection = false,
  queryFilters = [],
}) => ({
  type,
  label,
  icon,
  color,
  entryGroup,
  collection,
  isRootCollection,
  isChildSubCollection,
  queryFilters,
});

// Canonical timeline type map shared by all timeline consumers.
export const TIMELINE_TYPES = {
  DAILY_NOTE: createTimelineType({
    type: 'daily_note',
    label: LOG_TYPES.log.displayLabel,
    icon: LOG_TYPES.log.icon,
    color: LOG_TYPES.log.palette.dot,
    entryGroup: 'dailyLog',
    collection: 'dailyLogs',
    isRootCollection: true,
  }),
  SENSORY_LOG: createTimelineType({
    type: 'sensory_log',
    label: 'Sensory Log',
    icon: '🧠',
    color: '#9C27B0',
    entryGroup: 'dailyHabit',
    collection: 'sensoryLogs',
  }),
  BEHAVIOR: createTimelineType({
    type: 'behavior',
    label: LOG_TYPES.behavior.displayLabel,
    icon: LOG_TYPES.behavior.icon,
    color: LOG_TYPES.behavior.palette.dot,
    entryGroup: 'dailyHabit',
    collection: 'behaviors',
  }),
  MOOD_LOG: createTimelineType({
    type: 'mood_log',
    label: LOG_TYPES.mood.displayLabel,
    icon: LOG_TYPES.mood.icon,
    color: LOG_TYPES.mood.palette.dot,
    entryGroup: 'dailyHabit',
    collection: 'moodLogs',
  }),
  MEDICATION_LOG: createTimelineType({
    type: 'medication_log',
    label: LOG_TYPES.medication.displayLabel,
    icon: LOG_TYPES.medication.icon,
    color: LOG_TYPES.medication.palette.dot,
    entryGroup: 'dailyHabit',
    collection: 'medicationLogs',
  }),
  FOOD_LOG: createTimelineType({
    type: 'food_log',
    label: LOG_TYPES.food.displayLabel,
    icon: LOG_TYPES.food.icon,
    color: LOG_TYPES.food.palette.dot,
    entryGroup: 'dailyHabit',
    collection: 'foodLogs',
  }),
  MEDICAL_EVENT: createTimelineType({
    type: 'medical_event',
    label: 'Medical Event',
    icon: '🏥',
    color: '#F44336',
    entryGroup: 'incident',
    collection: 'medicalEvents',
  }),
  SLEEP_LOG: createTimelineType({
    type: 'sleep_log',
    label: LOG_TYPES.sleep.displayLabel,
    icon: LOG_TYPES.sleep.icon,
    color: LOG_TYPES.sleep.palette.dot,
    entryGroup: 'dailyHabit',
    collection: 'dailyLogs',
    isRootCollection: true,
    queryFilters: [
      { field: 'category', op: '==', value: 'sleep' },
      { field: 'status', op: '==', value: 'completed' },
    ],
  }),
  DAILY_CARE: createTimelineType({
    type: 'daily_care',
    label: 'Daily Care',
    icon: '📋',
    color: '#607D8B',
    entryGroup: 'dailyHabit',
    collection: 'dailyCare',
    isRootCollection: true,
  }),
  CHILD_TIMELINE: createTimelineType({
    type: 'child_timeline',
    label: 'Timeline Entry',
    icon: '⏰',
    color: '#795548',
    entryGroup: 'dailyHabit',
    collection: 'timeline',
    isChildSubCollection: true,
  }),
};

export const getTimelineTypeConfig = (type) => (
  Object.values(TIMELINE_TYPES).find((config) => config.type === type) || null
);
